/* eslint-disable */
import { connect } from 'react-redux';
import { getScreenData, runSaga, Store, setScreenData, showDialog, ACTIVE_SCREEN_KEY } from 'cw-ui-core';
import { takeLatest, cancel, put, call } from 'redux-saga/effects';
import map from 'lodash/map';
import isEqual from 'lodash/isEqual';
import {
    selectedPendingIdsMemoized,
    selectedActiveIdsMemoized,
} from 'src/features/users-v2/components/NewUsers/NewUsersContainerMemorizedUtils';
import { toArray, toMap } from 'src/util/Util';
import { selectedDisabledIdsMemoized } from 'src/features/users-v2/components/NewUsers/NewUsersContainerMemorizedUtils';
import { loadUsersWithConnectedApps, SearchForNewUsersAuth, loadUsers } from 'src/services/UsersService';
import { loadLoginProvidersWithoutUserCount } from 'src/services/LoginProviderService';
import { loadRoles } from 'src/services/RolesService';
import NewUsers from 'src/features/users-v2/components/NewUsers/NewUsers';
import {
    LOCAL_LOGIN,
    NEW_DISABLE_USER_DIALOG,
    NEW_ENABLE_USER_DIALOG,
    NEW_DELETE_USERS_DIALOG,
    NEW_RESET_PASSWORD_USER_DIALOG,
    NEW_RESEND_INVITE_USER_DIALOG,
    NEW_AUTHENTICATION_METHOD_USER_DIALOG,
} from 'src/features/users-v2/constants';
import { clearAlertMessages } from 'src/features/authentication-v2/components/utils';

const mapStateToProps = (state, ownProps) => {
    const screenKey = ownProps.screenKey || ACTIVE_SCREEN_KEY;
    const isEmbedded = ownProps.embedded;
    const selectedIds = toArray(getScreenData(state.screen, ['selectedUsers'], screenKey));
    const users = isEmbedded
        ? toArray(getScreenData(state.screen, ['users'], screenKey))
        : toArray(getScreenData(state.screen, ['usersWithConnectedApps'], screenKey));
    const selectedUsers = toArray(getScreenData(state.screen, ['selectedUsers'], screenKey));
    const loginProviders = toArray(getScreenData(state.screen, ['loginProviders'], screenKey));
    const loginProvidersFilter = map(loginProviders, provider => provider?.name);
    loginProvidersFilter.push(LOCAL_LOGIN);
    const totalUsers = getScreenData(state.screen, ['totalCount'], screenKey);
    const usersSearchText = getScreenData(state.screen, ['usersSearchText'], screenKey);

    const isUsersReady = getScreenData(state.screen, ['isReady'], screenKey);
    const isUsersForAppRoleLoading = getScreenData(state.screen, ['isUsersForAppRoleLoading'], screenKey);
    const isUsersFailedToLoad = getScreenData(state.screen, ['isUsersFailedToLoad'], screenKey);
    const roles = toArray(getScreenData(state.screen, ['roles'], screenKey));
    const identityRoles = map(roles, role => role?.name);
    const selectedActiveIds = selectedActiveIdsMemoized(state);
    const selectedPendingIds = selectedPendingIdsMemoized(state);
    const selectedDisabledIds = selectedDisabledIdsMemoized(state);
    const shouldNotShowAlert = ownProps.shouldNotShowAlert ?? false;
    const readOnly = ownProps.readOnly ?? false;

    return {
        isUsersForAppRoleLoading,
        users,
        readOnly,
        totalUsers,
        usersSearchText,
        selectedUsers,
        selectedDisabledIds,
        isUsersReady,
        loginProvidersFilter,
        identityRoles,
        shouldNotShowAlert,
        isUsersFailedToLoad,
        disabledOnNoneSelect: selectedIds.length === 0,
        disabledUnlessPendingSelect: selectedPendingIds ? selectedPendingIds.length === 0 : true,
        disableWhenActiveSelected: !!(selectedActiveIds && selectedActiveIds.length > 0),
        disabledUnlessActiveSelect: selectedActiveIds ? selectedActiveIds.length === 0 : true,
        disabledOnExternalAuthSelect: users.filter(u => u?.loginScheme !== null).some(v => selectedIds?.includes(v.id)),
        disbaleOnDisabledSelected: !!(selectedDisabledIds && selectedDisabledIds.length > 0),
        disabledUnlessDisabledSelect: !isEqual(selectedIds.length, selectedDisabledIds.length),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    let takeLatestTaskForFilterUsers;
    const screenKey = ownProps.screenKey || ACTIVE_SCREEN_KEY;
    const isEmbedded = ownProps.embedded;
    return {
        onDidMount: async () => {
            clearAlertMessages(screenKey);
            isEmbedded
                ? runSaga(loadUsers, null, null, null, null, screenKey)
                : runSaga(loadUsersWithConnectedApps, 1, 50, null, null, screenKey);
            runSaga(function* () {
                takeLatestTaskForFilterUsers = yield takeLatest('FILTER_USERS', SearchForNewUsersAuth, screenKey);
            });

            await Store().runSaga(function* () {
                yield put(setScreenData(['isProviderReady'], false, screenKey));
                yield call(loadLoginProvidersWithoutUserCount, screenKey);
                yield call(loadRoles, screenKey);
                yield put(setScreenData(['isProviderReady'], true, screenKey));
                dispatch(setScreenData(['usersSearchText'], '', screenKey));
                dispatch(setScreenData(['filters'], {}, screenKey));
            });
        },
        componentWillUnmount: () => {
            if (takeLatestTaskForFilterUsers && takeLatestTaskForFilterUsers.isRunning()) {
                Store().runSaga(function* () {
                    yield cancel(takeLatestTaskForFilterUsers);
                });
            }
            dispatch(setScreenData(['usersSearchText'], '', screenKey));
            dispatch(setScreenData(['filters'], {}, screenKey));
            if (!ownProps?.preserveSelection) {
                dispatch(setScreenData('selectedUsers', [], screenKey));
            }
            clearAlertMessages(screenKey);
        },

        onPaginationChange: (pageIndex, pageSize) => {
            const filters = toMap(getScreenData(Store().getState().screen, ['filters'], screenKey));
            const usersSearchText = getScreenData(Store().getState().screen, ['usersSearchText'], screenKey);
            Store().runSaga(loadUsersWithConnectedApps, pageIndex, pageSize, usersSearchText, filters, screenKey);
        },
        filterChange: (rolesFilter, authenticationFilter, statusFilter, mfaFilter, usersSearchText) => {
            const filters = { rolesFilter, authenticationFilter, statusFilter, mfaFilter };
            dispatch(setScreenData(['filters'], filters), screenKey);
            isEmbedded
                ? runSaga(loadUsers, null, null, null, null, screenKey)
                : runSaga(loadUsersWithConnectedApps, 1, 50, usersSearchText, filters, screenKey);
        },
        onSearchInputChange: e => {
            if (isEmbedded) {
                runSaga(loadUsers, null, null, e.target.value, null, screenKey);
            }
            runSaga(loadUsersWithConnectedApps, 1, 50, e.target.value, null, screenKey);
        },
        onSelection: newSelectionModel => {
            dispatch(setScreenData(['selectedUsers'], newSelectionModel, screenKey));
        },

        onDisableSelect: () => {
            const { screen } = Store().getState();
            const selectedIds = toArray(getScreenData(screen, ['selectedUsers'], screenKey));
            dispatch(showDialog(NEW_DISABLE_USER_DIALOG, { selectedIdsToDisable: selectedIds }));
        },
        onEnableSelect: () => {
            const { screen } = Store().getState();
            const selectedIds = toArray(getScreenData(screen, ['selectedUsers'], screenKey));
            dispatch(showDialog(NEW_ENABLE_USER_DIALOG, { selectedIdsToEnable: selectedIds }));
        },
        onDeleteSelect: () => {
            const { screen } = Store().getState();
            const selectedIds = toArray(getScreenData(screen, ['selectedUsers'], screenKey));
            dispatch(showDialog(NEW_DELETE_USERS_DIALOG, { selectedIdsToDelete: selectedIds }));
        },
        onResendInvite: () => {
            const { screen } = Store().getState();
            const selectedIds = toArray(getScreenData(screen, ['selectedUsers'], screenKey));
            dispatch(
                showDialog(NEW_RESEND_INVITE_USER_DIALOG, {
                    selectedIdsForResendInvite: selectedIds,
                })
            );
        },
        onResetPassword: () => {
            const { screen } = Store().getState();
            const selectedIds = toArray(getScreenData(screen, ['selectedUsers'], screenKey));
            dispatch(
                showDialog(NEW_RESET_PASSWORD_USER_DIALOG, {
                    selectedIdsForResetPassword: selectedIds,
                })
            );
        },
        onAuthMethodSelect: () => {
            const { screen } = Store().getState();
            const selectedIds = toArray(getScreenData(screen, ['selectedUsers'], screenKey));
            dispatch(
                showDialog(NEW_AUTHENTICATION_METHOD_USER_DIALOG, {
                    selectedIdsForAuth: selectedIds,
                })
            );
        },
    };
};

const NewUsersContainer = connect(mapStateToProps, mapDispatchToProps)(NewUsers);

export default NewUsersContainer;
